import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "@/lib/analytics";

export default function AnalyticsRouter() {
  const loc = useLocation();
  useEffect(() => { initAnalytics(); }, []);
  useEffect(() => {
    // Don't track admin routes
    if (loc.pathname.startsWith("/admin")) return;
    trackPageView(loc.pathname + loc.search, document.title);
  }, [loc.pathname, loc.search]);
  return null;
}
